<template>
  <div class="home-page-notify" v-if="viewable">
    <dialog-zoomer v-on:close="lbHide" v-model="viz">
      <div class="close-box small grey" v-on:click="lbHide"></div>
      <div class="panel-dialog">
        <div v-if="$store.state.lang === 'FR'">
          <div class="home-pop-image">
            <placed-image url="homepop/marie.jpg" />
          </div>
          <div class="h2">Bonjour et bienvenue chez  IllustrationX</div>
          <p>
              Sur notre site, vous pouvez découvrir les books d'environ 200 des 
              meilleurs illustrateurs au monde.
          </p>
          <p>
              Leurs styles varient, tous passionnants, certains classiques, d'autres  contemporains ou avant gardistes…
          </p>
          <p>
              Nous sommes une agence professionnelle, engagée auprès de nos auteurs qui viennent des quatre 
              coins du monde et nous proposons un important éventail de ressources créatives.
          </p>
          <p>
              Je suis votre interlocuteur, je suis basée à Paris et je travaille avec Illustration Ltd, 
              en parallèle de ma propre agence, depuis plus de 20 ans. Si vous avez des questions ou des 
              projets dont vous aimeriez parler, je serais ravie d'échanger avec vous, par téléphone ou par e-mail.
          </p>
          <p>
              Marie Bastille<br />
              01 45 26 70 09<br />
              marie@illustrationx.com
          </p>
        </div>
        <div v-if="$store.state.lang === 'DE'">
          <div>
            <div>
              <p>
                We are forwarding you to our sister agency in Germany, which has the same content as illustrationx.com. 
              </p>
              <p>
                Please click here to  <small-button v-on:click="germanStay">remain on the international site</small-button>. 
              </p>
              <p>
                Thank you.
              </p>
            </div>
          </div>
        </div>
        <div v-if="$store.state.lang === 'SX'">
          <div class="home-pop-image">
            <placed-image url="homepop/ana.jpg" />
          </div>
          <div class="h2">
            ¡Hola, bienvenidos!
          </div>
          <p>
              Es un inmenso honor formar parte del equipo de agentes de Illustration y tener la oportunidad de representar a más de 150 artistas muy talentosos, premiados y establecidos en una enorme variedad de estilos en el mundo del la ilustración internacional.

          </p>
          <p>
              Nuestra misión es ofrecer a los clientes de América Latina soluciones creativas exclusivas e innovadoras en ilustración, atendiendo demandas de diferentes tamaños. Desde una única ilustración editorial hasta un libro ilustrado completo; desde una acción de marketing digital para un pequeño negocio hasta campañas publicitarias completas para grandes anunciantes.

          </p>
          <p>
              Asi que quédese a gusto para explorar los portafolios en nuestro sitio. Y por supuesto, no dude en ponerse en contactarme para discutir las necesidades de su proyecto. ¡Será un placer ayudarte a encontrar el artista perfecto para tu idea, dentro de tu presupuesto y en el plazo ideal!

          </p>
          <p>
              Email: <a href="mailto:ana@illustrationx.com">ana@illustrationx.com</a><br />
              Skype : anacristina.bandarra<br />
              Mobile/whattsapp: +55 21 99773 7378 <br />
          </p>
        </div>
        <div v-if="$store.state.lang === 'BR'">
           <div class="home-pop-image">
            <placed-image url="homepop/ana.jpg" />
          </div>
          <div class="h2">
            Olá, sejam bem-vindos!
          </div>
          <p>
              É uma imensa honra fazer parte do time de agentes da Illustration e ter a oportunidade de representar 
              mais de 150 artistas talentosíssimos, 
              premiados e estabelecidos em uma enorme variedades de estilos no mundo da ilustração internacional.
          </p>
          <p>
              Nossa missão é oferecer para os clientes da América Latina soluções criativas exclusivas e inovadoras 
              em ilustração, atendendo demandas de diferentes tamanhos. Desde uma única ilustração editorial até um 
              livro ilustrado completo; desde uma ação de marketing digital para um pequeno negócio até campanhas publicitárias 
              completas para grandes anunciantes. 

          </p>
          <p>
              Então fique a vontade para explorar os portfólios em nosso site. E claro, não hesite em entrar contato 
              comigo para discutir as necessidades da sua idéia. Será um prazer te ajudar a encontrar o artista perfeito para o seu projeto, dentro do seu orçamento e no prazo ideal!

          </p>
          <p>
              Email: <a href="mailto:ana@illustrationx.com">ana@illustrationx.com</a><br />
              Skype : anacristina.bandarra<br />
              Mobile/whattsapp: 55 21 997737378<br />
          </p>
        </div>
        <div v-if="$store.state.lang === 'CN'">
          <div class="home-pop-image">
            <placed-image url="contacts/47.jpg" />
          </div>
          <p>
            嗨 ，你好，我是代理人Amary Tang , 感谢您打开我们的网站，我将帮助您找到最佳的项目解决方案,
            Illustration Ltd总部设立在伦敦，成立至今有80多年的历史，现在同时在全球6个国家地区展开插图代理经纪服务的工作。Illustration Ltd在中国已经有将近10年的发展时间，和国内很多一线品牌和著名企业都有过成功的合作经历，我们可以为中国客户提供增值税发票，并已经取得了ICP许可。
          </p>
          <p>
            我们代理了200多位当今世界上最优秀的插图艺术家和动画艺术家，告诉我您的需求，我将在第一时间给到您回复。 
          </p>
          <p>
            您可以拨打我的电话或加微信：13816864601 ，发送电子邮件 ：<a href="mailto:amary@illustrationx.com">amary@illustrationx.com</a> </p>
          <p>
            联系我，让我带领您走进插图和动画的世界吧！
          </p>
          <hr />
          <div style="margin-top:20px">
            <p style="font-weight:bold">
              寻找代理人助手
            </p>
            <p>
              Illustration Ltd 中国办事处因业务增长需求,寻找兼职助理
            </p>
            <p>
              工作任务:<br>

              -更新和管理微信和微博上的社交媒体新闻<br>

              -与世界各地的艺术家、客户和代理商沟通，<br>

              -客户工作委托的翻译，以及双方在委托期间的沟通<br>

              -更新和翻译艺术家和机构的新闻在网站上<br>

              -向客户做作品集展示<br>

              -支持本地营销工作<br>

              -物色新的插图师推荐给团队<br>

              希望你是一个艺术或文学相关专业毕业, 会photoshop, word的基础操作.<br>
              有一定的待人处事经验, <br>
              英语流利,中文表达有文采.<br>
              上海地区优先考虑,欢迎在家带娃有时间有历练的年轻妈妈来尝试.<br>
              待遇面议
            </p>
          </div>
        </div>
      </div>
    </dialog-zoomer>
  </div>
</template>

<script>
import DialogZoomer from './DialogZoomer.vue'
import PlacedImage from '@/components/widgets/PlacedImage.vue'
const poplangs = ['CN', 'BR', 'SX', 'FR','DE']
export default {
  components: {
    DialogZoomer,
    PlacedImage
  },
  data () {
    return {
      viz: false,
      canGoToGermany: true
    }
  },
  mounted () {
    if(this.viewable) {
      this.launch()
    }
  },
  computed: {
    viewable () {
      
      let lang = this.$store.state.lang
      if(!poplangs.includes(lang)) return false
      if(this.$store.state.poplangViewed.includes(lang)) return false
      if(this.$k.isBot()) return false
      if(this.$k.isPrerender()) return false
      return true
    }
  },
  methods: {
    async launch () {
      await this.$k.waitfor(2000)
      if(this.viewable) {
        this.viz = true
        if(this.$store.state.lang === 'DE') {
          await this.$k.waitfor(5000)
          if(this.canGoToGermany) {
            window.location = 'https://www.illustratoren.de/'
          }
        }
      }
    },
    async lbHide () {
      this.viz = false
      await this.$k.waitfor(500)
      this.$store.commit('addPoplangView', this.$store.state.lang)
    },
    germanStay() {
      this.canGoToGermany = false
      this.viz = false
    }
  }
}
</script>

<style>
.panel-dialog{
  width:90vw;
  max-width: 700px;
  background-color:#e8e8e3;
  z-index:5001;
  padding:35px;
  cursor:default;
  max-height:90vh;
  overflow-y:auto;
  box-sizing: border-box;
  border-radius:6px;
}

.home-pop-image{
  width:30%;
  float:right;
  margin:20px;
}
</style>